import { getZrmListingInfo, getZrmUserInfo } from '@zg-rentals/clickstream';

import { trackEvent } from '../index';

import type { ValueOf } from 'type-fest';
import type { ZrmClickstreamListing, ZrmClickstreamUser } from '@zg-rentals/clickstream';
import type { TRIGGER_LOCATIONS } from '../../constants/ClickstreamConstants';

export const EVENT_IDS = {
  VIEW_CONTENT: '5312',
  CLICK_YES: '5309',
  CLICK_NO: '5310',
  CLICK_CLEAR: '5311',
  INFO_POPOVER: '6146',
} as const;

// https://dataportal.zillowgroup.net/event-registry/5312
export const emitRentersInsuranceViewContentEvent = ({
  currentProperty,
  user,
  triggerLocation,
}: {
  currentProperty: ZrmClickstreamListing;
  user: ZrmClickstreamUser;
  triggerLocation: ValueOf<typeof TRIGGER_LOCATIONS>;
}) =>
  trackEvent.listingUser({
    envelope: {
      event_type_id: EVENT_IDS.VIEW_CONTENT,
      event_type_version_id: '1',
      event_template_id: '168',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: 'impression',
      trigger_location_nm: triggerLocation,
      trigger_source_nm: 'posting_path',
      trigger_object_nm: 'renters_insurance_question',
    },
    semantic: {
      semantic_event_nm: 'view_content',
      topic_tag_txt: ['zrm_properties'],
    },
    ...getZrmListingInfo(currentProperty),
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/5309
export const emitRentersInsuranceClickYesEvent = ({
  currentProperty,
  user,
  triggerLocation,
}: {
  currentProperty: ZrmClickstreamListing;
  user: ZrmClickstreamUser;
  triggerLocation: ValueOf<typeof TRIGGER_LOCATIONS>;
}) =>
  trackEvent.listingUser({
    envelope: {
      event_type_id: EVENT_IDS.CLICK_YES,
      event_type_version_id: '1',
      event_template_id: '168',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: 'interaction',
      trigger_location_nm: triggerLocation,
      trigger_source_nm: 'renters_insurance_required_yes',
      trigger_object_nm: 'no_trigger_object',
    },
    semantic: {
      semantic_event_nm: 'create_listing',
      topic_tag_txt: ['zrm_properties'],
    },
    ...getZrmListingInfo(currentProperty),
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/5310
export const emitRentersInsuranceClickNoEvent = ({
  currentProperty,
  user,
  triggerLocation,
}: {
  currentProperty: ZrmClickstreamListing;
  user: ZrmClickstreamUser;
  triggerLocation: ValueOf<typeof TRIGGER_LOCATIONS>;
}) =>
  trackEvent.listingUser({
    envelope: {
      event_type_id: EVENT_IDS.CLICK_NO,
      event_type_version_id: '1',
      event_template_id: '168',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: 'interaction',
      trigger_location_nm: triggerLocation,
      trigger_source_nm: 'renters_insurance_required_no',
      trigger_object_nm: 'no_trigger_object',
    },
    semantic: {
      semantic_event_nm: 'create_listing',
      topic_tag_txt: ['zrm_properties'],
    },
    ...getZrmListingInfo(currentProperty),
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/5311
export const emitRentersInsuranceClickClearEvent = ({
  currentProperty,
  user,
  triggerLocation,
}: {
  currentProperty: ZrmClickstreamListing;
  user: ZrmClickstreamUser;
  triggerLocation: ValueOf<typeof TRIGGER_LOCATIONS>;
}) =>
  trackEvent.listingUser({
    envelope: {
      event_type_id: EVENT_IDS.CLICK_CLEAR,
      event_type_version_id: '1',
      event_template_id: '168',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: 'interaction',
      trigger_location_nm: triggerLocation,
      trigger_source_nm: 'renters_insurance_required_clear',
      trigger_object_nm: 'no_trigger_object',
    },
    semantic: {
      semantic_event_nm: 'create_listing',
      topic_tag_txt: ['zrm_properties'],
    },
    ...getZrmListingInfo(currentProperty),
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/6146
export const emitRentersInsuranceInfoPopoverEvent = ({
  currentProperty,
  user,
  triggerLocation,
}: {
  currentProperty: ZrmClickstreamListing;
  user: ZrmClickstreamUser;
  triggerLocation: ValueOf<typeof TRIGGER_LOCATIONS>;
}) =>
  trackEvent.listingUser({
    envelope: {
      event_type_id: EVENT_IDS.INFO_POPOVER,
      event_type_version_id: '1',
      event_template_id: '168',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: 'interaction',
      trigger_location_nm: triggerLocation,
      trigger_source_nm: 'help_tooltip',
      trigger_object_nm: 'renters_insurance_question',
    },
    semantic: {
      semantic_event_nm: 'view_tooltip',
      topic_tag_txt: ['zrm_properties'],
    },
    ...getZrmListingInfo(currentProperty),
    ...getZrmUserInfo(user),
  });
